module.exports = __webpack_public_path__ + "files/d400826bb73d5fd51b9141edc8e171c4.png";